module.exports = __webpack_public_path__ + "img/rocrocot.4c47406c.png";